import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/edit-icon.svg'


const _hoisted_1 = { class: "review-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Patient Information", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "review-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Insurance Information", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_7 = { class: "review-table" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", null, "FSA Plan Administrator:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Are you the primary account holder:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Member ID or Account Number:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Employer/Company Name", -1)
const _hoisted_12 = { class: "review-header" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "Claim Information", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_15 = { class: "review-table" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "Item name:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "Purchased From:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("th", null, "Purchase date:", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", null, "Cost:", -1)
const _hoisted_20 = {
  key: 0,
  class: "divider"
}

import { computed } from "vue";
import FsaVariables from "@/types/FsaVariables";
import FsaFormSteps from "@/types/FsaFormSteps";
import Item from "@/types/FsaItem";
import FormTitle from "../common/FormTItle.vue";
import ReviewPatientInfo from "../common/ReviewPatientInfo.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  props: {
    modelValue: {},
    variables: {},
    items: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;





const currentStep = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(FormTitle, {
            title: "Review (1/2)",
            description: "Please review this information for accuracy before continuing."
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).User))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).User))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_3,
              _createVNode(ReviewPatientInfo, { variables: _ctx.variables }, null, 8, ["variables"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).FSA))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).FSA))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_6,
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("tr", null, [
                  _hoisted_8,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.planAdministrator), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.isAccountHolder ? "Yes" : "No"), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.memberId), 1)
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_11,
                  _createElementVNode("td", null, _toDisplayString(_ctx.variables.employerOrCompanyName), 1)
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card, { class: "card-container" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_v_spacer),
                _createElementVNode("img", {
                  class: "edit-icon",
                  src: _imports_0,
                  alt: "edit icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).Claim))
                }),
                _createVNode(_component_v_btn, {
                  class: "edit-btn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (currentStep.value = _unref(FsaFormSteps).Claim))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update information ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_14,
              _createElementVNode("table", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-2",
                    key: i
                  }, [
                    _createElementVNode("h3", null, "Item " + _toDisplayString(i + 1), 1),
                    _createElementVNode("tr", null, [
                      _hoisted_16,
                      _createElementVNode("td", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      _createElementVNode("td", null, _toDisplayString(item.provider), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_18,
                      _createElementVNode("td", null, _toDisplayString(item.date), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_19,
                      _createElementVNode("td", null, "$" + _toDisplayString(item?.cost?.toFixed(2)), 1)
                    ]),
                    (i != Object.keys(_ctx.items).length - 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})